export const FETCH_FINAL_CHARGES_REQUEST = "FETCH_FINAL_CHARGES_REQUEST";
export const FETCH_FINAL_CHARGES_SUCCESS = "FETCH_FINAL_CHARGES_SUCCESS";
export const FETCH_FINAL_CHARGES_FAILURE = "FETCH_FINAL_CHARGES_FAILURE";
export const FETCH_FINAL_CHARGES_RESET = "FETCH_FINAL_CHARGES_RESET";
export const fetchFinalChargeslogRequest = (payload) => ({
    type: FETCH_FINAL_CHARGES_REQUEST,
    payload,
});
export const fetchFinalChargeslogSuccess = (payload) => ({
    type: FETCH_FINAL_CHARGES_SUCCESS,
    payload,
});
export const fetchFinalChargeslogFailure = (payload) => ({
    type: FETCH_FINAL_CHARGES_FAILURE,
    payload,
});
export const fetchFinalChargeslogReset = () => ({
    type: FETCH_FINAL_CHARGES_RESET,
});
